export default "__VITE_ASSET__BfDsCase__"